import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import ImageUpload from '@components/ImageUpload';
import ModalContainer from '@components/modals/ModalContainer';
import { toastError } from '@components/Toast';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { addSubcategory, fetchSubCategory } from '@services/measurementService';

const AddSubCategory = ({
	parentCategoryId,
	actionValue,
	onCloseModal,
	onddSuccess,
	onUpdateSubCategory
}) => {
	const [formData, setFormData] = useState(null);
	const [errors, setErrors] = useState({});
	const dispatch = useDispatch();

	useEffect(() => {
		if (actionValue !== 'ADD') {
			onFetchSubCategories();
		}
	}, []);

	const onFetchSubCategories = async () => {
		try {
			dispatch(openLoader());
			let data = await fetchSubCategory(actionValue?.id);
			data.documentDTO = data.documentResponse;
			delete data.documentResponse;
			setFormData(data);
			dispatch(closeLoader());
		} catch (error) {
			dispatch(closeLoader());
			toastError(error.message);
		}
	};

	const isValidForm = () => {
		let newErrors = {};
		if (!formData?.name) {
			newErrors = { ...newErrors, nameError: 'Sub ctaegory is required' };
		}
		// if (isAdd && !body.documentDTO) {
		// 	newErrors = { ...newErrors, imageError: 'Photo is required' };
		// }
		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const onImageUpload = async (data) => {
		setFormData({ ...formData, documentDTO: data });
	};

	const onPomSubmit = async () => {
		let body = formData;
		try {
			dispatch(openLoader());
			const isValid = isValidForm(body);
			if (!isValid) {
				dispatch(closeLoader());
				return;
			}
			const responseData =
				actionValue === 'ADD'
					? await addSubcategory(body, parentCategoryId)
					: await onUpdateSubCategory(body);
			actionValue === 'ADD' && onddSuccess(responseData?.id);
			onCloseModal();
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};
	return (
		<ModalContainer className="pom-upload-subcategory">
			<div className="common-popup  pom-upload-modal shadow-24dp">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">
							{actionValue === 'ADD' ? 'Add' : 'Edit'} Sub-category
						</h3>
					</div>
					<div className="close-btn" onClick={onCloseModal}>
						<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
					</div>
				</div>
				<div className="common-popup-body">
					<div className="row">
						<div className="col-md-4 pr-2">
							<div className="upload-section">
								{formData?.documentDTO ? (
									<>
										<img
											className="border-0"
											src={
												formData?.documentDTO?.docUrl ||
												formData?.documentDTO?.base64Str ||
												process.env.PUBLIC_URL + '/icons/pom/t-shirt.png'
											}
											alt="edit"
										/>
										<ImageUpload
											size="sm"
											onUploadImage={onImageUpload}
											docType={'PRODUCT_DESIGN'}
											type={'image'}
											isEditable={true}
										/>
									</>
								) : (
									<ImageUpload
										size="sm"
										onUploadImage={onImageUpload}
										docType={'PRODUCT_DESIGN'}
										type={'image'}
									/>
								)}
							</div>
						</div>
						<div className="col-md-8 pr-2">
							<div className="row">
								<div className="col-md-12">
									<div className="form-group">
										<label htmlFor="collection">Sub Category*</label>
										<input
											type="text"
											className="w-100"
											onChange={(e) =>
												setFormData({ ...formData, name: e.target.value })
											}
											value={formData?.name}
										/>
										{errors.nameError && <p className="error">{errors.nameError}</p>}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32" onClick={onCloseModal}>
							Cancel
						</button>
						<button className="button size32 ml-2" onClick={onPomSubmit}>
							Submit
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default AddSubCategory;
